import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header/Header";
import AboutContainer from "./About/AboutContainer";
import CardContainer from "./Cards/CardContainer";
import Why from "./Why/Why";
import Choose from "./Choose/Choose";
import DematAccount from "./DematAccount/DematAccount";
import "./Home.scss";

export class Home extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Algoquant Global ~ Home</title>
        </Helmet>
        <div className="wrapper homePage">
          <Header />
          <AboutContainer />
          <CardContainer />
          <Why />
          <Choose />
          <DematAccount />
        </div>
      </>
    );
  }
}

export default Home;
